<template>
    <div class="">
        <Carousel class="space-section__cont" :items-to-show="1.1" :wrap-around="true">
            <Slide v-for="image in images" :key="image.id">
                <div class="space-section__item">
                    <img :src="`https://spacebarprod-16905.kxcdn.com/public-assets/${image.slug}?size=desktop-2`" class="img-fluid" :alt="image.alt" loading="lazy">
                </div>
            </Slide>
            <template #addons>
                <Navigation />
            </template>
        </Carousel>
    </div>
</template>

<script>
import { defineComponent } from 'vue'
import { Carousel, Navigation, Slide } from 'vue3-carousel'


export default defineComponent({
    props: {
        images: Array
    },
    name: 'WrapAround',
    components: {
        Carousel,
        Slide,
        Navigation,
    },
})
</script>

<style lang="scss">
@import 'https://cdn.jsdelivr.net/npm/vue3-carousel@0.2.9/dist/carousel.min.css';

.carousel__prev.carousel__prev--disabled {
    display: none;
}

.accordion-body,
.accordion-button {
    font-family: inherit;
}

.accordion-button:hover {
    color: inherit;
}
.space-section__item{
    width: 98%;
    margin: auto;
}
.space-section__cont{
    position: relative;
    &::before{
        position: absolute;
        content: '';
        top: 0;
        left: -1px;
        width: 3.8%;
        height: 100%;
        background-color: rgba(255, 255, 255, 0.563);
        z-index: 1;
    }
    &::after{
        position: absolute;
        content: '';
        top: 0;
        right: -1px;
        width: 3.8%;
        height: 100%;
        background-color: rgba(255, 255, 255, 0.563);
        z-index: 1;
    }
}
.carousel__next, .carousel__prev {
    z-index: 2;
}

</style>